<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-8"></a>
<h2 class="chapname"><span class="chaps">L</span>IST OF ABBREVIATIONS</h2>
<p class="lista"><span class="ts31">Adm. </span><span class="ts4">Admiralty or Admiralty Records in TNA</span></p>
<p class="lista"><span class="ts31">BCA </span><span class="ts4">British Columbia Archives, Victoria, BC</span></p>
<p class="lista"><span class="ts31">Bod. L. </span><span class="ts4">Bodleian Library, Oxford</span></p>
<p class="lista"><span class="ts31">BL </span><span class="ts4">British Library Manuscripts (formerly in the British Museum), London</span></p>
<p class="lista"><span class="ts31">BT </span><span class="ts4">Board of Trade Records in TNA</span></p>
<p class="lista"><span class="ts31">Cab. </span><span class="ts4">Cabinet Papers in TNA</span></p>
<p class="lista"><span class="ts31">CDC </span><span class="ts4">Colonial Defence Committee</span></p>
<p class="lista"><span class="ts31">CMS </span><span class="ts4">Church Missionary Society or Church Missionary Society Records, University of Birmingham</span></p>
<p class="lista"><span class="ts31">CO </span><span class="ts4">Colonial Office or Colonial Office Records in TNA</span></p>
<p class="lista"><span class="ts31">FO </span><span class="ts4">Foreign Office or Foreign Office Records in TNA</span></p>
<p class="lista"><span class="ts31">HBC </span><span class="ts4">Hudson’s Bay Company</span></p>
<p class="lista"><span class="ts31">HBCA </span><span class="ts4">Hudson’s Bay Company Archives, Winnipeg, Manitoba</span></p>
<p class="lista"><span class="ts31">HM </span><span class="ts4">Her/His Majesty</span></p>
<p class="lista"><span class="ts31">HMCS </span><span class="ts4">Her/His Majesty’s Canadian Ship</span></p>
<a id="VPS-9"></a>
<p class="lista"><span class="ts31">HMS </span><span class="ts4">Her/His Majesty’s Ship</span></p>
<p class="lista"><span class="ts31">HMSO </span><span class="ts4">His/Her Majesty’s Stationery Office</span></p>
<p class="lista"><span class="ts31">HO </span><span class="ts4">Hydrographer’s Office, Taunton, Somerset</span></p>
<p class="lista"><span class="ts31">KCB/CB </span><span class="ts4">Knight Commander or Companion of the Order of the Bath</span></p>
<p class="lista"><span class="ts31">LAC </span><span class="ts4">Library and Archives Canada, Ottawa, Ontario</span></p>
<p class="lista"><span class="ts31">MMBC </span><span class="ts4">Maritime Museum of British Columbia, Victoria, BC</span></p>
<p class="lista"><span class="ts31">NL </span><span class="ts4">Naval Library, Ministry of Defence, Royal Naval Museum, Portsmouth, England</span></p>
<p class="lista"><span class="ts31">NMM </span><span class="ts4">National Maritime Museum, Greenwich (now part of Royal Museums Greenwich)</span></p>
<p class="lista"><span class="ts31">PRO </span><span class="ts4">Public Records Office</span></p>
<p class="lista"><span class="ts31">RCS </span><span class="ts4">Royal Commonwealth Society Collections, Cambridge University Library, Cambridge</span></p>
<p class="lista"><span class="ts31">RE </span><span class="ts4">Royal Engineers</span></p>
<p class="lista"><span class="ts31">RM </span><span class="ts4">Royal Marines</span></p>
<p class="lista"><span class="ts31">RMLI </span><span class="ts4">Royal Marine Light Infantry</span></p>
<p class="lista"><span class="ts31">RN </span><span class="ts4">Royal Navy</span></p>
<p class="lista"><span class="ts31">TNA </span><span class="ts4">The National Archives, Kew, Surrey</span></p>
<p class="lista"><span class="ts31">USN </span><span class="ts4">United States Navy</span></p>
<p class="lista"><span class="ts31">USS </span><span class="ts4">United States Ship</span></p>
<p class="lista"><span class="ts31">WO </span><span class="ts4">War Office or War Office Records in TNA</span></p>
<p class="lista"><span class="ts31">WRO </span><span class="ts4">Warwickshire Record Office, Warwick</span></p>
<p class="lista"><span class="ts31">12n26 </span><span class="ts4">In a bibliographic note, refers to, in this example, note 26 on page 12</span></p>
<a id="VPS-10"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List_of_abbreviations.vue?38946569